<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <admin-sidebar-menu v-if="admin" />
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
            <h3 class="d-inline heading">Edit Group</h3>
          </div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>

          <div class="content-main-wrapper signin-form add_account_form center">
            <form @submit.prevent="onSubmit">
          		<div class="row margin-bottom-15">
          		  <div class="col-12 col-sm-12">
            			<label
            					for="group_name"
            					class="col-12">Group name : <span class="required">*</span></label>
            			<input
            					type="group_name"
            					name="group_name"
            					id="group_name"
            					class="col-12 col-sm-12 input-height-35"
            					ref="group_name"
            					v-validate="'required'"
                      data-vv-as="Group name"
            					v-model="name"
                      maxlength="180">
            			<div v-show="verrors.has('group_name')" class="validate-warning-msg">{{ verrors.first('group_name') }}</div>
          		  </div>
          		</div>
              <div class="row margin-bottom-15">
                <div class="col-12 col-sm-12">
            			<label
            					for="parent_group"
            					class="col-12"> Parent group :</label>
                  <b-form-select
                    v-model="parent_group_id"
                    :options="groups"
                    class="mb-3"
                    name="parent_group"
                    data-vv-as="Parent group"  v-if="groups" />
                </div>
              </div>

              <div class="row margin-bottom-15">
                <div class="col-12 col-sm-12">
                  <label
                      for="instructors"
                      class="col-12">Select at least one instructor to include in the group:<span class="required">*</span></label>
                  <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(instructor, key, index) in instructorlists">
                    <div class="chkboxwrapper" v-if="key == 0">
                      <input :value="instructor.id" :id="instructor.id" type="checkbox" name="instructor_assigned"
                                          v-validate data-vv-rules="required" v-model="instructor_assigned" data-vv-as="Instructor" class="float-left" style="margin-top: 2px;" >
                      <label :for="instructor.name" class="float-left" style="margin-left: 4px;">{{ instructor.name }}</label>
                    </div>
                    <div class="chkboxwrapper" v-else>
                      <input :value="instructor.id" :id="instructor.id" type="checkbox" name="instructor_assigned"
                                          v-model="instructor_assigned" class="float-left" style="margin-top: 2px;" >
                      <label :for="instructor.name" class="float-left" style="margin-left: 4px;">{{ instructor.name }}</label>
                    </div>
                    <div style="clear: both;"></div>
                  </div>
                  <div v-show="verrors.has('instructor_assigned')" class="validate-warning-msg">{{ verrors.first('instructor_assigned') }}</div>
               </div>
              </div>

              <div class="row margin-bottom-15">
                <div class="col-12 col-sm-12">
                  <label
                      for="roles"
                      class="col-12">Tasklists to be assigned :</label>
                  <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(tasklist, key, index) in tasklists">
                    <div class="chkboxwrapper">
                      <input :value="tasklist.id" :id="tasklist.id" type="checkbox" name="tasklist_assigned" v-model="tasklist_assigned" class="float-left" style="margin-top: 2px;" >
                      <label :for="tasklist.name" class="float-left" style="margin-left: 4px;">{{ tasklist.name }}</label>
                      <div style="clear: both;"></div>
                    </div>
                  </div>
               </div>
              </div>

              <div class="submit margin-bottom-15">
                <button type="submit" class="btn btn-info btn-md">Update</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../../router/index.js';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';
import store from '../../store/store.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  data: function () {
    return {
      name: '',
      groups: [],
      groups_assigned: [],
      tasklists: [],
      instructorlists: [],
      parent_group_id: '',
      instructor_assigned:[],
      tasklist_assigned:[],
      groupId: this.$route.params.group_id,
      admin: false,
    }
  },
  methods: {
  onSubmit () {
      this.$validator.validateAll().then((result) => {
        if(!result) {
          return;
        }
        this.updateGroup();
      })
      .catch(() => {

      });
 },
  updateGroup() {
        axios('/groups/'+this.groupId,
          {
            method: 'PATCH',
            data: {
                 name: this.name,
                 parent_group_id: this.parent_group_id,
                 instructors: this.instructor_assigned,
                 tasklists: this.tasklist_assigned},
             }
          )
       .then((resp) => {
         this.flash({ message: resp.data.successMsg, variant: 'success' });
         this.navigate("/school-admin-dashboard");
        })
       .catch(error => {
           const fieldErrors =  [{}];
             var errMsgObj = error.response.data.message;

             Object.keys(errMsgObj).map(key => {
                var newFieldErr = {field:key, msg:errMsgObj[key]};
                fieldErrors.push(newFieldErr);
             });
             this.$validator.errors.add(fieldErrors);
       });
  },
  navigate(path) {
    router.push(path);
  },
  },
  beforeCreate() {

      axios('/accountgroups',
        {
          method: 'GET',
          params: {
            account_id: this.$store.state.user_accountid,
          }
        },
      )
      .then(response => {
         var defaultGroup = {value: '', text: 'Please select'};
         this.groups.push(defaultGroup);

         for(var i=0; i < response.data.length; i++) {
           var group = {value: response.data[i].id, text: response.data[i].groupName};
           this.groups.push(group);
         }
       })
      .catch(error => {

      });

      axios('/alltasklists-account',
        {
          method: 'GET',
        },
      )
      .then(response => {
            this.tasklists = response.data;
       })
      .catch(error => {

      });

      axios('/instructors-account',
        {
          method: 'GET',
        },
      )
      .then(response => {
            this.instructorlists = response.data;
       })
      .catch(error => {

      });

  },
  created() {
      axios('/groups/'+this.groupId,
        {
          method: 'GET',
        },
      )
      .then(response => {
            this.name = response.data.name;
            this.instructor_assigned = response.data.instructors;
            this.parent_group_id = response.data.parentGroup;
            if(response.data.groupTasklists.length > 0) {
                this.tasklist_assigned = response.data.groupTasklists;
            }
       })
      .catch(error => {

      });
      var roles = this.$store.state.roles;
      if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
        this.admin = true;
      }
  },
  components: {
    UserMenu,
    GoBack,
    AdminSidebarMenu
  }
}
</script>

<style>
.tasklist-assign-wrapper label {
  font-weight: normal;
}
.tasklist-assign-wrapper .chkboxwrapper {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/primaryadmin/edit_group.vue